// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ep-0";
export var headerCellHover = "_ep-1";